import { Mixin } from 'mixwith';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseApprovedNode(representation) {
        return {
          id: representation.attributes.enclosed_element.nodeValue,
          ignore: true,
        };
      }
    },
);
